<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>ADD COURSE</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-6"></vs-divider>

    <vs-select
      autocomplete
      @input-change="autoCompleteEmail"
      class="items-center justify-between px-6 mt-4 mb-6"
      multiple
      width="100%"
      v-validate="{ required: true }"
      label="Email"
      v-model="selectEmail"
    >
      <vs-select-item
        :key="index"
        :value="item.email"
        :text="item.email"
        v-for="(item, index) in allUsers"
      />
    </vs-select>
    <vs-select
      autocomplete
      multiple
      v-validate="{ required: true }"
      @input-change="autoCompleteCourses"
      class="items-center justify-between px-6 mt-6 mb-6"
      width="100%"
      label="Course"
      v-model="selectCourses"
    >
      <vs-select-item
        :key="index"
        :value="item._id"
        :text="item.title"
        v-for="(item, index) in courses"
      />
    </vs-select>

    <!-- <div class="vx-col w-1/3 items-center sm:flex hidden mt-6">
        <vs-button @click="addUserCourse()">Save</vs-button>
      </div> -->

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="addUserCourse()" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button type="border" color="danger" @click="close()"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selectEmail: [],
      selectCourses: [],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  watch: {
    selectCourses(val) {
      this.autoCompleteCourses(val)
    },
    selectEmail(val) {
      this.autoCompleteEmail(val)
    },
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {
          _id,
          cid,
          category,
          coverPage,
          title,
          isEnabled,
          description,
          price,
          duration
        } = JSON.parse(JSON.stringify(this.data))
        // console.log('destructyred data', _id, cid, category, coverPage, title, isEnabled, description, price, duration)
        this.dataId = _id
        this.dataCid = cid
        this.dataCategory = category
        this.dataImg = coverPage
        this.dataUploadedFile = coverPage
        // this.dataVid = vid
        this.dataTitle = title
        this.enableCourse = isEnabled
        this.dataDescription = description
        this.dataPrice = price
        this.dataDuration = duration
        // this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    allUsers() {
      return this.$store.state.userCourses.allUsers
    },
    courses() {
      return this.$store.state.userCourses.courses
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.selectEmail && this.selectCourses
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    close() {
      this.isSidebarActiveLocal = false
      this.selectCourses = []
      this.selectEmail = []
    },
    addUserCourse() {
      if (this.selectEmail.length && this.selectCourses.length) {
        let payload = {
          courses: this.selectCourses,
          email: this.selectEmail
        }
        this.$store.dispatch('userCourses/addUserCourses', payload)
        this.isSidebarActiveLocal = false
        this.dialogAddData = false
        payload = {}
        this.selectCourses = []
        this.selectEmail = []
      }
    },
    autoCompleteCourses() {
      console.log(this.selectCourses)
    },
    autoCompleteEmail() {
      console.log(this.selectEmail)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
